// eslint-disable-next-line
import { injectable } from "inversify";
import { IApiResponse, IHttpService } from "../http-service";
import { TYPE, rootContainer } from "../container/root";

export interface ICoverageSettings {
    is_selling_coverage: boolean;
    fees_management_option: COVERAGE_FEES_MANAGMENT_OPTIONS;
    selection_method_option: COVERAGE_SELECTION_METHOD_OPTIONS;
    show_coverage_settings_page: boolean;
    is_sysadmin: boolean;
}

export interface IShopifyExtensionData {
    is_shopify_extension_enabled: boolean;
    shopify_extension_url: string;
}

export enum COVERAGE_FEES_MANAGMENT_OPTIONS {
    WAIVE_ALL = 'waive-all',
    WAIVE_LABEL_ONLY = 'waive-label-only',
}

export enum COVERAGE_SELECTION_METHOD_OPTIONS {
    TOGGLE = 'toggle',
    CHECKBOX = 'checkbox',
}

@injectable()
class CoverageService {
    private readonly httpService: IHttpService = rootContainer.get<IHttpService>(TYPE.ApiHttp);

    public async fetchCoverageSettings(): Promise<ICoverageSettings> {
        const res = await this.httpService.get<IApiResponse<ICoverageSettings>>(`/rms-api/coverage-settings/fetch-coverage-settings`);
        return res.payload;
    }

    public async fetchShopifyExtensionData(): Promise<IShopifyExtensionData> {
        const res = await this.httpService.get<IApiResponse<IShopifyExtensionData>>(`/rms-api/coverage-settings/fetch-shopify-extension-data`);
        return res.payload;
    }

    public async saveCoverageSettings(settings: ICoverageSettings): Promise<ICoverageSettings> {
        const res = await this.httpService.post<IApiResponse<ICoverageSettings>>(`/rms-api/coverage-settings/save`, settings);
        return res.payload;
    }

    public async enableShowCoverageSettingsPage(): Promise<void> {
        await this.httpService.post(`/rms-api/coverage-settings/enable-show-coverage-settings-page`);
    }

}

export default CoverageService;
